module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-header"
  }, [_c('div', {
    staticClass: "row align-items-center cat-header-container"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12 col-xs-12 px-6"
  }, [(_vm.isUserChildrentList || !_vm.isParentUser) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cat-body"
  }, [(!_vm.catComment) ? [_c('span', {
    staticClass: "cat-title"
  }, [_vm._v(_vm._s(_vm.$t('common.sam_loading')))])] : [_c('span', {
    staticClass: "cat-title"
  }, [_vm._v(_vm._s(_vm.$t('common.sam_hello')) + "\n            " + _vm._s(_vm.isParentUser ?
    _vm.$t('common.sam_parent_greeting', {
      user: _vm.selectedChildName
    }) :
    _vm.$t('common.sam_student_greeting', {
      user: _vm.userName
    })) + ",")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "cat-description"
  }, [_vm._v("\n            " + _vm._s(_vm.catComment()) + "\n          ")])]], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-12 col-xs-12 p-14"
  }, [(_vm.isPremiumSchool) ? [_c('span', {
    staticClass: "premium-school-text"
  }, [_vm._v(_vm._s(_vm.$t('common.premium_school')))])] : _vm._e(), _vm._v(" "), (_vm.isParentUser) ? [_c('div', {
    staticClass: "child-filter"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.selectedChildName,
      "variant": "variant"
    }
  }, [_vm._l((_vm.userChildrenList), function(item) {
    return _c('b-dropdown-item', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.selectChild(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.openChildSettings()
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('common.child_add')))])], 2)], 1)] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/img-main-sam.png",
      "alt": "sam"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db8e578","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatHeader.vue
// module id = 1598
// module chunks = 1